import { createGlobalStyle } from "styled-components";

export const BackgroundColor = createGlobalStyle`
    html {
        --background-color: #${(props) => (props.color !== null ? props.color : "#13266e")};
`;
